import Sidebar from "@/components/Sidebar";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function AppLayout({ children }) {
  const [platformName, setPlatformName] = useState("KREPP");
  useEffect(() => {
    api.get("/public/billing-config").then(({ data }) => {
      if (data?.platform_name) setPlatformName(data.platform_name);
    }).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-background flex">
      <Sidebar platformName={platformName} />
      <main className="flex-1 min-w-0 px-8 py-8 animate-fade-up" data-testid="app-main">
        {children}
      </main>
    </div>
  );
}
